<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd conmon-top"
         style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype"
             style="line-height: 48px;border: none">
          <div class="demo-input-suffix"
               style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select v-model="formInlineTmp.public_id"
                       placeholder="请选择"
                       clearable
                       @change='getData'>
              <el-option v-for="item in publicNumber"
                         :key="item.id"
                         :label="item.nick_name"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-flod-content search-content search-input-group common-search-formtype"
             style="padding: 0;border: none">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   class="search-content-item"
                   label-width="95px">
            <el-form-item label="活动类型：">
              <el-select filterable
                         v-model="formInlineTmp.activity_id"
                         placeholder="请选择">
                <el-option v-for="item in activities"
                           :key="item.id"
                           :label="item.activity_name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起止时间：">
              <el-date-picker class="micro-page-picker"
                              style="width:350px!important;"
                              v-model="timePickerDate"
                              type="daterange"
                              value-format="yyyy-MM-dd"
                              @blur="verifyTime"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="业务员：">
              <el-input clearable
                        @keyup.enter.native="searchData"
                        v-model.trim="formInlineTmp.nickname"
                        placeholder="请输入业务员"
                        ></el-input>
            </el-form-item>
            <el-form-item label="部门：">
              <el-input @keyup.enter.native="searchData"
                        v-model.trim="formInlineTmp.department"
                        placeholder="请输入部门名称"
                        clearable
                        ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-button type="primary"
                   @click="addOfflineAcivityAction"
                   class="add-btn btn-right"
                   style="float: right;">分配</el-button>
        <el-button type="primary"
                   class="search-btn-new list-btn-margin"
                   @click="downloadCustomer">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData"
                v-loading="load"
                class="table">
        <el-table-column label="场次名称"
                         width="270">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="top">
              <p>{{ scope.row.qrcode_name }}</p>
              <div slot="reference"
                   class="name-wrapper">
                {{ scope.row.qrcode_name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column width="180"
                         label="扫码次数/关注/参与人数">
          <template slot-scope="scope">
            <span>{{ scope.row.scan_num }}</span>
            /<span>{{ scope.row.subscribe_num }}</span>
            <span v-if="scope.row.replay_type === 3">
              /{{ scope.row.canyu_num }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="90"
                         label="二维码">
          <template slot-scope="scope">
            <img @click="showQRcode(scope.row.qrcode_url)"
                 src="/static/img/qrcode.png"
                 width="30px">
          </template>
        </el-table-column>
        <el-table-column label="姓名"
                         width="110"
                         prop="saleman_name">
        </el-table-column>
        <el-table-column label="手机号"
                         width="210"
                         prop="mobile">
        </el-table-column>
        <el-table-column width="210"
                         label="活动类型">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="top">
              <p>{{ scope.row.activity_name }}</p>
              <div slot="reference"
                   class="name-wrapper">
                {{ scope.row.activity_name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="部门"
                         width="220">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="top">
              <p>{{ scope.row.structure_name }}</p>
              <div slot="reference"
                   class="name-wrapper">
                {{ scope.row.structure_name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         width="150">
          <template slot-scope="scope">
            {{ scope.row.create_time.substring(0, 16) }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="120"
                         fixed="right"
                         style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link"
                 @click="toToTAL(scope.row.id, activity_id)">
              统计
            </div>
            <div class="op-link"
                 @click="deleteActivity(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新建弹窗-->
      <el-dialog @close="closeNewSet"
                 class="cellDialog base-dialog"
                 title="分配场次"
                 :visible.sync="QrcodeDialog"
                 width="540px">
        <el-form label-position="right"
                 :inline="true"
                 :model="form"
                 ref="form"
                 :rules="rules"
                 label-width="90px">
          <el-form-item prop="activity_id"
                        label="活动类型:">
            <el-select filterable
                       v-model="form.activity_id"
                       placeholder="请选择活动类型">
              <el-option v-for="item in activitiess"
                         :key="item.id"
                         :label="item.activity_name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场次名称:"
                        prop="qrcode_name">
            <el-input v-model="form.qrcode_name"
                      placeholder="请输入场次名称"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="业务员:"
                        prop="saleman_id">
            <el-select v-model="form.salesman_id"
                       placeholder="请选择业务员"
                       filterable
                       >
              <el-option v-for="item in salesmanOptions"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer"
             style="margin-top: 10px">
          <el-button class="dialog-cancel-btn"
                     @click="QrcodeDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn"
                     style="margin-right: 32px"
                     type="primary"
                     :disabled="isDisabled"
                     @click="submitForm('form')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 二维码弹窗-->
      <el-dialog class="cellDialog base-dialog"
                 title="二维码"
                 :visible.sync="QRViewDialog"
                 width="500px">
        <img :src="QRImage"
             style="width: 240px; height: 240px;">
      </el-dialog>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { exportFieldManage, getqrcodeActivityList, getStructureList, getSalesmanList, deleteActivityList, addActivityQrcode, getWeChatActivityListForFiled, getWechatPublicListForNode, getActivityStatics } from '@/api/customer.js'
export default {
  name: 'fieldManage',
  data () {
    return {
      formInlineTmp: {},
      load: true,
      original_id: '',
      publicNumber: [],
      activities: [],
      timePickerDate: '',
      timeout: null,
      QrcodeDialog: false,
      QRViewDialog: false,
      isDisabled: false,
      QRImage: '',
      activity_id: 0,
      public_id: 0,
      addGradeForm: {
        grade: '',
        grade_list: []
      },
      addGradeDialog: false,
      formInline: {
        structure_id: '',
        public_id: '',
        nickname: '',
        activity_id: '',
        start_time: '',
        end_time: ''
      },
      form: {
        qrcode_name: '',
        activity_id: '',
        salesman_id: ''
      },
      qrcode_name: '',
      salesman_id: '',
      search: {
        keyword: '',
        qrcode_name: '',
        structure_name: ''
      },
      search_saleman: {
        public_id: ''
      },
      structureOptions: [],
      activitiess: [],
      salesmanOptions: [],
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      rules: {
        activity_id: [
          { required: true, message: '请选择活动类型', trigger: 'change' }
        ],
        qrcode_name: [
          { required: true, message: '请输入二维码名称', trigger: 'blur' }
        ],
        saleman_id: [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    searchData () {
      if (this.timePickerDate === null) {
        this.formInlineTmp.start_time = ''
        this.formInlineTmp.end_time = ''
      } else {
        this.formInlineTmp.start_time = this.timePickerDate[0]
        this.formInlineTmp.end_time = this.timePickerDate[1]
      }
      this.formInline.public_id = this.formInlineTmp.public_id
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.loadData()
    },
    // 关闭分配
    closeNewSet () {
      if (this.QrcodeDialog === false) {
        this.form.qrcode_name = ''
        this.form.activity_id = ''
        this.form.salesman_id = ''
      }
    },
    // 切换公众号
    getData () {
      this.formInline.public_id = this.formInlineTmp.public_id
      this.loadData()
    },
    // 请求公众号
    getWechatPublicListForNodes () {
      getWechatPublicListForNode(1).then(res => {
        for (let item of res.data.data.list) {
          if (item.is_default === 1) {
            this.formInlineTmp.public_id = item.id
          }
        }
        this.publicNumber = res.data.data.list
        this.formInline.public_id = this.formInlineTmp.public_id
        this.loadData()
      })
    },
    querySearchAsync (queryString, cb) {
      var restaurants = this.salesmanOptions
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants
    },
    createStateFilter (queryString) {
      return (state) => {
        return state.name.indexOf(queryString) !== -1
      }
    },
    handleSelect (item) {
    },
    // 判断开始结束时间大小
    verifyTime () {
      if (this.timePickerDate === null) {
        return
      }
      if (Date.parse(new Date(this.timePickerDate[0])) > Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    addOfflineAcivityAction () {
      this.QrcodeDialog = true
    },
    deleteActivity (id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivityList(id).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.loadData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      })
    },
    toToTAL (Id, activity_id) {
      let modelId = 0
      for (let item of this.publicNumber){
        if (item.id == this.formInlineTmp.public_id) {
          console.log('item model', item.id, this.formInlineTmp.public_id, item.modelId)
          modelId = item.model_id
          break
        }
      }
      router.push({
        path: '/home/offline-acitivity-statistics',
        query: {
          id: Id,
          model_id: modelId,
          activity_id: activity_id
        }
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.loadData()
    },
    handleCurrentChange (page) {
      this.page = page
      this.loadData()
    },
    // 打开看二维码大图
    showQRcode (url) {
      this.QRViewDialog = true
      this.QRImage = url
    },
    // 导出
    downloadCustomer () {
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let search = {}
      if (!this.hide) {
        search = this.allTerms
      } else {
        search = {
          allRelationship: 'or',
          termsGroup: [
            {
              inOperator: 'or',
              terms: [
                {
                  attr: 'attr',
                  secAttr: 'realname',
                  relationship: 'contain',
                  value: this.search.keywords
                },
                {
                  attr: 'attr',
                  secAttr: 'nickname',
                  relationship: 'contain',
                  value: this.search.keywords
                },
                {
                  attr: 'attr',
                  secAttr: 'mobile',
                  relationship: 'contain',
                  value: this.search.keywords
                }
              ]
            }
          ]
        }
      }
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      exportFieldManage(this.formInline).then(response => {
        this.download(response)
      }).catch((error) => {
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 获取部门数据
    getStructureData () {
      getStructureList().then(res => {
        this.structureOptions.push({
          id: '',
          name: '全部'
        })
        for (let item of res.data.data.list) {
          this.structureOptions.push({
            id: item.id,
            name: item.name
          })
        }
      })
    },
    // 获取活动类型
    getWeChatActivityListForFileds (page) {
      this.formInline.public_id = this.formInlineTmp.public_id
      getWeChatActivityListForFiled(1, '', this.formInline.public_id).then(res => {
        res.data.data.list.unshift({ id: '', activity_name: '全部' })
        this.activities = res.data.data.list
      })
    },
    // 获取活动类型（非全部）
    getWeChatActivityListForFiledss (page) {
      this.formInline.public_id = this.formInlineTmp.public_id
      getWeChatActivityListForFiled(1, '', this.formInline.public_id).then(res => {
        this.activitiess = res.data.data.list
      })
    },
    // 新建弹窗提交
    submitForm () {
      if (this.form.activity_id === '') {
        _g.toastMsg('error', '请选择活动类型')
        return
      }
      if (this.form.qrcode_name === '') {
        _g.toastMsg('error', '请输入场次名称')
        return
      }
      if (this.form.salesman_id === '') {
        _g.toastMsg('error', '请选择业务员')
        return
      }
      this.QrcodeDialog = false
      addActivityQrcode(this.form.qrcode_name, this.form.salesman_id, this.form.activity_id).then(res => {
        if (res.data.code === 0) {
          this.QrcodeDialog = false
          this.isDisabled = false
          this.form.qrcode_name = ''
          this.form.salesman_id = ''
          _g.toastMsg('success', res.data.error)
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
        this.loadData()
      })
    },
    // 列表数据
    loadData () {
      this.load = true
      // 获取场次列表数据
      // this.formInline.start_time = this.timePickerDate[0]
      // this.formInline.end_time = this.timePickerDate[1]
      let getqrcodeActivityLists = getqrcodeActivityList(this.page, this.limit, this.formInline)
      // 获取业务员
      let getSalesmanDatas = getSalesmanList(1, this.formInline, 10000)
      // 获取活动类型
      let getWeChatActivityListForFiledsa = getWeChatActivityListForFiled(1, '', this.formInline.public_id)
      // 获取活动类型无全部
      let getWeChatActivityListForFiledssb = getWeChatActivityListForFiled(1, '', this.formInline.public_id)
      // 发送promiss请求并处理
      Promise.all([getqrcodeActivityLists, getSalesmanDatas, getWeChatActivityListForFiledsa, getWeChatActivityListForFiledssb]).then(res => {
        // 获取场次列表
        if (res[0].data.code === 0) {
          this.totalCount = res[0].data.data.total
          this.tableData = res[0].data.data.list
          console.log('this.tableData', res[0].data.data.list)
        }
        // 业务员列表
        if (res[1].data.code === 0) {
          for (let item of res[1].data.data.list) {
            item.name = item.realname
          }
          this.salesmanOptions = res[1].data.data.list
        }
        // 获取活动类型列表查询
        if (res[2].data.code === 0) {
          res[2].data.data.list.unshift({ id: '', activity_name: '全部' })
          this.activities = res[2].data.data.list
        }
        // 获取活动类型弹窗
        if (res[3].data.code === 0) {
          this.activitiess = res[3].data.data.list
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.load = false
      }, 500)
    }
  },
  created () {
    this.loading = true
    let limit_salesman = 0
    this.activity_id = this.$route.query.id
    this.formInline.activity_id = this.$route.query.id
    this.getStructureData()
    this.getWechatPublicListForNodes()
  }
}
</script>

<style scoped>
.name-wrapper {
  width: 90%;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
</style>
